<template>
	<div>
		<BaseActionBar v-if="isAdmin" :items="actions" />
		<BaseTable
			:is-loading="isLoading"
			:pagination="pagination"
			:fields="ONLINE_GROUP_TABLE_FIELDS"
			:items="tableData"
			:hide-columns="['id']"
			:sort-columns="{
				branch_id: query.sort_by === 'branch_id' ? (query.sort_direction || 'asc') : 'asc',
				branch_name: query.sort_by === 'branch_name' ? (query.sort_direction || 'asc') : 'asc'
			}"
			striped
			hover
			fixed
			class="table-custom"
			@onSortClick="handleSortClick"
		>
			<template #no-items-view>
				<div class="empty-table-element">
					<p class="subtitle">
						{{ $t('message.notFoundBranchList') }}
					</p>
				</div>
			</template>
		</BaseTable>

		<!-- Modal Branch -->
		<ModalBranch
			ref="modal-branch"
			:title="$t('message.select_branches')"
			:selected-branches="selectedIds"
			@onSubmit="handleSubmit"
		/>
		<!-- End Modal Branch -->
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import useSelectBranch from '../use/selectBranch';
import { cleanObject, cloneDeep } from '../helpers/utils';
import { ONLINE_GROUP_TABLE_FIELDS } from '../enums/allocation';

export default {
	name: 'AllocationOnlineGroupList',

	props: {
		id: {
			type: [String, Number],
			default: null,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		pagination: {
			type: Object,
			default: () => ({}),
		},
		tableData: {
			type: Array,
			default: () => [],
		},
		branchIds: {
			type: Array,
			default: () => [],
		},
		temporaryBranches: {
			type: Array,
			default: () => [],
		},
		query: {
			type: Object,
			default: () => ({}),
		},
	},

	setup(props, context) {
		const options = {
			defaultState: {
				selectedValues: props.branchIds,
				temp: props.temporaryBranches,
			},
		};

		const {
			selectedIds,
			selectedAll,
			selectedCount,
			selectedCountFriendly,
			handleSubmit,
			handleFetch,
		} = useSelectBranch(props, context, options);

		return {
			selectedIds,
			handleSubmit,
			selectedAll,
			selectedCount,
			selectedCountFriendly,
			handleFetch,
		};
	},

	data() {
		return {
			ONLINE_GROUP_TABLE_FIELDS,
		};
	},

	computed: {
		...mapGetters('me', {
			isAdmin: 'isAdmin',
		}),
		actions() {
			return [
				{
					onClick: () => {
						this.$refs['modal-branch'].open();
					},
					icon: ['far', 'plus'],
					color: 'secondary',
					text: this.$t('button.assign_branch'),
					disabled: this.isLoading,
				},
			];
		},
	},

	methods: {
		handleSortClick(key = '', state = false) {
			this.query.sort_by = key;
			this.query.sort_direction = state;
			this.updateUrl();
		},
		updateUrl() {
			const query = cleanObject(cloneDeep(this.query));
			this.$router.push({ query }).catch(() => {});
		},
	},
};
</script>
